import { render, staticRenderFns } from "./DvTipTap.vue?vue&type=template&id=2f5b23aa&scoped=true&lang=pug"
import script from "./DvTipTap.vue?vue&type=script&lang=js"
export * from "./DvTipTap.vue?vue&type=script&lang=js"
import style0 from "./DvTipTap.vue?vue&type=style&index=0&id=2f5b23aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b23aa",
  null
  
)

export default component.exports